import PersonaMainView from "./PersonaMainView";

export {PersonaMainView}
export default PersonaMainView
